import { render, staticRenderFns } from "./Consultants.vue?vue&type=template&id=5afce468&scoped=true"
import script from "./Consultants.vue?vue&type=script&lang=js"
export * from "./Consultants.vue?vue&type=script&lang=js"
import style0 from "./Consultants.vue?vue&type=style&index=0&id=5afce468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afce468",
  null
  
)

export default component.exports